/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import endUsersManagementSlice, {
	END_USERS_MANAGEMENT_KEY_IN_STORE,
} from './slice';
import { endUsersManagementSaga } from './sagas';

export class EndUsersManagementModule {
	getRootKeyInStore(): string {
		return END_USERS_MANAGEMENT_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return endUsersManagementSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return endUsersManagementSaga;
	}
}

export const moduleInstance = new EndUsersManagementModule();
